import { connect } from 'react-redux'
import { isMobileOnly } from 'react-device-detect'

import withDidMountRequest from 'app/connectors/withDidMountRequest'
import { getStoriesList } from 'store/entities/stories/selectors'
import { storiesScroll, storiesList } from 'store/entities/stories/actions'
import StoriesList from './StoriesList'

const mapStateToProps = state => ({
  storiesList: getStoriesList(state),
  isMobileOnly,
})

const mapDispatchToProps = {
  onRequest: storiesList.get.request,
  handleScroll: ({ currentTarget }) => storiesScroll(currentTarget),
}

export default connect(mapStateToProps, mapDispatchToProps)(withDidMountRequest(StoriesList))
